import Cadastro from 'assets/png/links/img-cadastro.png'
import Connect from 'assets/png/links/img-connect.png'
import Despesas from 'assets/png/links/img-despesas.png'
import Remuneracao from 'assets/png/links/img-remuneracao.png'
import Showroom from 'assets/png/links/img-showroom.png'
import Simplus from 'assets/png/links/img-simplus.png'
import Trade from 'assets/png/links/img-trade.png'
import Whatsapp from 'assets/png/links/img-whatsapp.png'

export interface LinkCardInterface {
  title: string
  description: string
  link: string
  image: string
}

export const links: LinkCardInterface[] = [
  {
    description: 'Ferramenta de trade para consultar o portfólio',
    image: Showroom,
    link: 'https://showroom.havaianas.com/login',
    title: 'Showroom virtual',
  },
  {
    description: 'Consulte aqui sua remuneração variável',
    image: Remuneracao,
    link: 'https://go.achievemore.com.br',
    title: 'Remuneração variável',
  },
  {
    description: 'Ferramenta com dados cadastrais dos materiais',
    image: Simplus,
    link: 'https://prod.simplustec.com.br/#/',
    title: 'Simplus',
  },
  {
    description: 'Confira as novidades de Trade',
    image: Trade,
    link: '',
    title: 'Trade Informa',
  },
  {
    description: 'Receba informações de Trade via WhatsApp',
    image: Whatsapp,
    link: '',
    title: 'Grupo do Whatsapp',
  },
  {
    description: 'Banco de ativos digitais da Havaianas',
    image: Connect,
    link: 'https://connect.havaianas.com/',
    title: 'Connect',
  },
  {
    description: 'Registre ou atualize dados de clientes',
    image: Cadastro,
    link: '',
    title: 'Solicitação de cadastro',
  },
  {
    description: 'Registre mensalmente seus gastos para reembolso',
    image: Despesas,
    link: 'https://www.portalalpargatas.com.br/Site/Portal/Home/HomeVazio.aspx?pa_cd_sist_menu=MDEV&pa_cd_grup_menu=MDEV',
    title: 'Mapa de despesas',
  },
]
